import TextM from "@common/components/text/TextM"
import { theme } from "@common/theme/theme"
import { plr } from "@data/utility/Utils"
import React from "react"
import { View } from "react-native"
import FontAwesome5 from "react-native-vector-icons/FontAwesome5"
import { useSelector } from "react-redux"

const AbsenceQuotaBadge = ({
    used,
    limit,
    windowMonths = 2,
    studentFirstname = null,
    style,
}) => {
    // Repli quand l'appelant n'a pas de prénom à donner : sans ça, un parent
    // lirait le tutoiement de l'élève.
    const isParentMode = useSelector(
        (state) => !!state?.data?.family?.isParentMode
    )

    if (used === null || used === undefined || !limit) return null

    const prospectiveUsed = used + 1
    const exceedsLimit = prospectiveUsed > limit
    const subjectClause = studentFirstname
        ? `${studentFirstname} aura utilisé`
        : isParentMode
        ? "votre enfant aura utilisé"
        : "tu auras utilisé"

    const accentColor = exceedsLimit ? theme.colors.error : theme.colors.primary
    const bgColor = exceedsLimit
        ? theme.colors.material.secondary["50"]
        : theme.colors.material.primary["50"]

    return (
        <View
            style={[
                {
                    backgroundColor: bgColor,
                    borderRadius: 16,
                    borderWidth: exceedsLimit ? 1 : 0,
                    borderColor: theme.colors.error,
                    padding: 14,
                    alignSelf: "center",
                    width: "100%",
                },
                style,
            ]}
        >
            <View
                style={{
                    flexDirection: "row",
                    alignItems: "center",
                    marginBottom: 8,
                }}
            >
                <FontAwesome5
                    name={exceedsLimit ? "exclamation-triangle" : "info-circle"}
                    solid
                    size={18}
                    color={accentColor}
                />
                <TextM
                    fontWeight={"ExtraBold"}
                    fontSize={16}
                    color={accentColor}
                    style={{ marginLeft: 8 }}
                >
                    Absences
                </TextM>
            </View>
            <TextM wrap style={{ lineHeight: 18 }}>
                En confirmant, {subjectClause}{" "}
                <TextM fontWeight={"SemiBold"}>
                    {prospectiveUsed} {plr("crédit", prospectiveUsed)}
                </TextM>{" "}
                d'absence sur les{" "}
                <TextM fontWeight={"SemiBold"}>
                    {limit} {plr("autorisé", limit)}
                </TextM>{" "}
                sur une période de {windowMonths} mois.
                {exceedsLimit
                    ? " Il est toujours possible de signaler l'absence pour prévenir le masteur, mais la séance ne pourra pas être rattrapée."
                    : ""}
            </TextM>
        </View>
    )
}

export default AbsenceQuotaBadge
